import DisplayFilesByLead from './DisplayFilesByLead.component';

export default DisplayFilesByLead;